import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-74703cd6")

_pushScopeId("data-v-74703cd6")
const _hoisted_1 = { class: "like-btn-total" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _directive_onTouchActive = _resolveDirective("onTouchActive")!

  return (_openBlock(), _createBlock("div", {
    class: ["like-btn-wrap", { active: _ctx.isLike }]
  }, [
    _withDirectives(_createVNode("div", {
      class: ["like-btn", _ctx.likeGtmClass],
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleLike()))
    }, [
      _createVNode("span", _hoisted_1, _toDisplayString(_ctx.totalNum), 1),
      _createVNode("span", {
        class: ["like-btn-add-text", { active: _ctx.isShowPlusText }]
      }, "+1", 2)
    ], 2), [
      [_directive_onTouchActive]
    ])
  ], 2))
})